import RadioGroup from './RadioGroup.vue'

/* istanbul ignore next */
RadioGroup.install = function (app) {
  app.component(RadioGroup.name, RadioGroup)
}

export default RadioGroup
